import Axios from 'utils/axios'
import listModules from './utils/listModules';

export default listModules({
    actions: {
        fetch({ commit, state }, payload) {
            const promise = Axios.post('/admin/userMaterial/list', payload)
            promise.then(function (res) {
                commit('update', {
                    list: res.list || [],
                })
            })
            return promise
        },
        save: '/admin/userMaterial/save',
        delete: '/admin/userMaterial/delete',
    }
});
